export default "__VITE_ASSET__DhYAftcr__"